import React from 'react';
import './PasswordToolTip.scss'; 
const PasswordTooltip = () => (
  <div className="popover">
    <p>
      Password must be at least <span>8 characters</span> and contain
      <span> 1 number</span>, <span>1 uppercase letter</span>, <span>1 lowercase letter</span> and <span>1 symbol</span>.
    </p>
  </div>
);

export default PasswordTooltip;
